var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":"","offset-y":""}},[_c('v-btn',_vm._g(_vm._b({attrs:{"slot":"activator","icon":"","flat":""},slot:"activator"},'v-btn',_vm.button,false),_vm.$listeners),[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_vm._t("default")],2),_c('span',[_vm._v(_vm._s(_vm.tooltip))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }